export const CREATE_TRACK_FEATURE = 'create-track';

// Chat is hidden on web for now; flip to true to bring back nav entries, /chat routes and chat buttons.
export const CHAT_ENABLED = false;
